import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'sites.Manage sites' | translate }}</h1>
            <a class="btn add" ui-sref="authorized.manage.permissions.sites.add()">{{ 'sites.Add site' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading">
            <table class="data01">
                <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'sites.Name' | translate }}</a></th>
                    <!--<th ng-class="vm.list.getSortClass('isActive')"><a ng-click="vm.list.sortBy('isActive')">{{ 'sites.Status' | translate }}</a></th>-->
                    <th ng-class="vm.list.getSortClass('isExternalSite')"><a ng-click="vm.list.sortBy('isExternalSite')">{{ 'sites.External site' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('externalId')"><a ng-click="vm.list.sortBy('externalId')">{{ 'sites.From external integration' | translate}}</a></th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                    <tr ng-repeat-start="item in vm.list.items" >
                        <td><a ui-sref="authorized.manage.permissions.sites.detail({ id: item.id })">{{ item.name }}</a></td>
                        <td ng-if="item.isExternalSite">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!item.isExternalSite">{{ 'general.No' | translate }}</td>
                        <td ng-if="item.externalId">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!item.externalId">{{ 'general.No' | translate }}</td>
                        <td class="actions">
                            <a class="btn delete" ng-click="vm.delete(item)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-if="item.childSites" ng-repeat-start="l2item in item.childSites" class="level02">
                        <td><a ui-sref="authorized.manage.permissions.sites.detail({ id: l2item.id })">{{ l2item.name }}</a></td>
                        <td ng-if="l2item.isExternalSite">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l2item.isExternalSite">{{ 'general.No' | translate }}</td>
                        <td ng-if="l2item.externalId">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l2item.externalId">{{ 'general.No' | translate }}</td>
                        <td class="actions">
                            <a class="btn delete" ng-click="vm.delete(l2item)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-if="l2item.childSites" ng-repeat-start="l3item in l2item.childSites" class="level03"}">
                        <td><a ui-sref="authorized.manage.permissions.sites.detail({ id: l3item.id })">{{ l3item.name }}</a></td>
                        <td ng-if="l3item.isExternalSite">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l3item.isExternalSite">{{ 'general.No' | translate }}</td>
                        <td ng-if="l3item.externalId">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l3item.externalId">{{ 'general.No' | translate }}</td>
                        <td class="actions">
                            <a class="btn delete" ng-click="vm.delete(l3item)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-if="l3item.childSites" ng-repeat-start="l4item in l3item.childSites" class="level04">
                        <td><a ui-sref="authorized.manage.permissions.sites.detail({ id: l4item.id })">{{ l4item.name }}</a></td>
                        <td ng-if="l4item.isExternalSite">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l4item.isExternalSite">{{ 'general.No' | translate }}</td>
                        <td ng-if="l4item.externalId">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l4item.externalId">{{ 'general.No' | translate }}</td>
                        <td class="actions">
                            <a class="btn delete" ng-click="vm.delete(l4item)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-if="l4item.childSites" ng-repeat-start="l5item in l4item.childSites" class="level05">
                        <td><a ui-sref="authorized.manage.permissions.sites.detail({ id: l5item.id })">{{ l5item.name }}</a></td>
                        <td ng-if="l5item.isExternalSite">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l5item.isExternalSite">{{ 'general.No' | translate }}</td>
                        <td ng-if="l5item.externalId">{{ 'general.Yes' | translate }}</td>
                        <td ng-if="!l5item.externalId">{{ 'general.No' | translate }}</td>
                        <td class="actions">
                            <a class="btn delete" ng-click="vm.delete(l5item)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor (ListFactory, SiteResource, $translate, ModalService, toastr) {
        this.list = ListFactory.createWithPagination(SiteResource.indexTree.bind(SiteResource));
        this.siteResource = SiteResource;
        this.list.fetch();
        this.$translate = $translate;
        this.modalService = ModalService;
        this.toastr = toastr;
    }

    delete (item) {
        let confirmMessage = this.$translate.instant('sites.Are you sure you wish to delete the site?');

        if (item.externalId) {
            confirmMessage = this.$translate.instant(
                'sites.The entry has been created by external integration. ' +
                'After deletion it could still be imported back into the system when the integration is started again. ' +
                'Are you sure you wish to delete the site?'
            );
        }

        this.modalService.confirm(confirmMessage, 'medium').then(() => {
            this.siteResource.delete({ id: item.id }).$promise.then(() => {
                this.list.fetch();
                this.toastr.success(this.$translate.instant('sites.Site deleted'));
            }).catch((response) => {
                this.toastr.error(response.data[0].message);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/sites/list/index.js